module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAYAAACaq43EAAAASElEQVRIx2M8J6j2n2EAAOOoxaMW08ziJ9VtxwbE4v2HH14ZEIt5ZHr+j1o8vC3++OnHwCSuiB7PgclOVuUa/0ctHrV4WFkMANx5KY1b494TAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/gm.png
// module id = 831
// module chunks = 0